document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".testimonials-carousel__swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    pagination: {
      el: ".testimonials-carousel__pagination",
      clickable: true,
    },
    breakpoints: {
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
      1280: { slidesPerView: 3 },
      1444: { slidesPerView: 3 },
      1920: { slidesPerView: 3 },
    },
  });
  function updateWrapperCentering() {
    const wrapper = document.querySelector(".swiper-wrapper-testimonials");
    if (!wrapper) return;

    const slides = wrapper.children.length;
    const breakpoints = swiper.params.breakpoints;
    const width = window.innerWidth;

    let visibleSlides = 1;
    for (let bp in breakpoints) {
      if (width >= bp) {
        visibleSlides = breakpoints[bp].slidesPerView;
      }
    }

    if (slides < visibleSlides) {
      wrapper.classList.add("swiper-wrapper--centered");
    } else {
      wrapper.classList.remove("swiper-wrapper--centered");
    }
  }

  // Run once on load
  updateWrapperCentering();

  // Run on resize
  window.addEventListener("resize", updateWrapperCentering);
  const reviewDates = document.querySelectorAll(".review-card__date");
  reviewDates.forEach((dateEl) => {
    const dateString = dateEl.dataset.reviewDate;
    if (!dateString) return;

    const reviewDate = new Date(dateString);

    const day = String(reviewDate.getDate()).padStart(2, "0");
    const month = String(reviewDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = reviewDate.getFullYear();

    dateEl.textContent = `${day}/${month}/${year}`;
  });

  const reviewCards = document.querySelectorAll(".review-card");

  reviewCards.forEach((card) => {
    const text = card.querySelector(".review-card__text");
    const button = card.querySelector(".review-card__see-more");

    if (text.scrollHeight > text.clientHeight) {
      button.style.display = "inline-block";

      button.addEventListener("click", () => {
        text.classList.toggle("scrollable");

        if (text.classList.contains("scrollable")) {
          button.textContent = "See Less";
        } else {
          button.textContent = "See More";
          text.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }
      });
    }
  });
});
